// extracted by mini-css-extract-plugin
module.exports = {"pie-labels":"PieChart_pie-labels__3RkzH","container":"PieChart_container__ZMMUc","label":"PieChart_label__JFY2A"};